<template>
    <div class="select-none flex flex-col gap-4 justify-between h-full 6 w-full bg-yellow-100 border border-yellow-200 text-yellow-600 text-sm p-6 rounded-2xl shadow-md"
         style="min-height: 244px">
        <template v-if="hasFeature('feat_maintenance_requests')">
            <template v-if="!loading && stats">
                <div class="flex flex-wrap gap-2 justify-center w-full">
                    <span class="font-medium text-xl">New Maintenance Requests</span>
                </div>

                <a :href="stats.new_requests.link" target="_blank"
                   class="flex items-center justify-center gap-x-4 hover:text-yellow-400 transition duration-300">
                    <icon-flag class="w-10 h-10"></icon-flag>
                    <span class="font-bold text-4xl">{{ stats.new_requests.stat }}</span>
                </a>

                <a :href="stats.past_twelve_hours.link" target="_blank"
                   class="flex justify-center items-center w-full hover:text-yellow-400 transition duration-300">
                    <span class="font-black text-lg px-2">{{ stats.past_twelve_hours.stat }}</span>
                    <span class="font-normal"> in the last 12 hours</span>
                </a>
            </template>

            <template v-else>
                <div class="flex justify-center items-center font-medium text-lg text-yellow-600">
                    <icon-refresh class="h-6 w-6 animate-spin"/> &nbsp;Loading...
                </div>
            </template>
        </template>

        <template v-else>
            <div class="flex flex-wrap gap-2 justify-center w-full">
                <span class="font-medium text-xl">Online Tenant Reporting</span>
            </div>

            <a href="/settings#/tab-billing" target="_blank" v-if="userCan('manage-billing')"
               class="flex items-center justify-center gap-x-4 hover:text-yellow-400 transition duration-300">
                <icon-flag class="w-10 h-10"></icon-flag>
                <span>Click here to upgrade now</span>
            </a>
            <div v-else class="flex justify-center">
                <icon-flag class="w-10 h-10"></icon-flag>
            </div>

            <div class="flex flex-col items-center justify-center space-y-4">
                <span> Available Now For <span class="font-bold">Enterprise Clients</span></span>

                <span> Have tenants report problems directly to your RedRabbit profile </span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "MaintenanceRequestsStatCard",

    data () {
        return {
            loading: true,
            stats: null
        };
    },

    mounted () {
        this.fetchStats();
    },

    methods: {
        fetchStats () {
            if (this.hasFeature("feat_maintenance_requests")) {
                this.loading = true;
                axios.get("/home/maintenance-requests/stats")
                .then(response => {
                    this.stats = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    toastr.error(error.data.message);
                });
            } else {
                this.loading = false;
            }
        },
    },
};
</script>
